var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoResults = function SvgNoResults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 120 120"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F09A7A",
    d: "M88.81 5c17.215 0 31.176 12.635 31.19 28.214-.207 10.836-5.605 43.64-56.02 80.517-1.237.826-2.53 1.269-3.989 1.269-1.288 0-2.564-.48-3.608-1.084C31.909 96.009.936 66.291 0 33.476v-.262C0 17.63 13.957 5 31.176 5c13.087 0 24.287 7.298 28.902 17.617C64.735 12.34 75.793 5 88.811 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00534A",
    d: "M63.792 76.494h-7.657L53.583 39h12.834zM67 86.204q0 2.986-2.042 4.929Q62.99 93 60 93t-5.031-1.867q-1.97-1.942-1.969-4.93t1.969-4.93q1.969-1.941 5.031-1.941 3.135 0 5.031 1.942 1.97 1.941 1.969 4.93"
  })));
};
export default SvgNoResults;